
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gnyy_45CPG9mK8L6WXKIz40HvaJW6PWiWUclMiTkMLu_tAMeta } from "/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexasd4dgS0LLTR7pI7ibPNR9TO5fNvWK4V6dkIQW_45E3yEMeta } from "/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchhuJ9lKb25zEuVwfaJHqS_qtbgNl_45D5vyjI0br5ezE_4Meta } from "/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexbnymVhBozUyZDNfM8SDYigNg6Tybn1EothemIVsvvlYMeta } from "/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_935TfpyHbaw98uIfqkMnOMp_45oiy66BaUBEuTIGiKPsTzEMeta } from "/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index5k5PohravIgHBlGdNsqr1jtPKBNdGeZMfQ_455fDU09B8Meta } from "/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93vZhZqQI7ebRn37YeA6cVHujLYF23gn2nDC65spKsOZ4Meta } from "/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index98QMwqwFlD7gqpIPLKSF26NgL_45NtbUPdgFTWQLdh_ZAMeta } from "/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93HGC2IY6zb2bLLVSIz9nNr24_7XAAEF98pBvxxYYI_9YMeta } from "/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexY9cgNsjit6XOFUtw9IUbDJ_459Wh2Gz3pxj9M6eGRI8ZAMeta } from "/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexvHIyihS_45_45JoZ_m7pyXlTn7AZ7hrC_4SMid8bIehMXuIMeta } from "/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index5k5PohravIgHBlGdNsqr1jtPKBNdGeZMfQ_455fDU09B8Meta || {},
    component: () => import("/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index98QMwqwFlD7gqpIPLKSF26NgL_45NtbUPdgFTWQLdh_ZAMeta || {},
    component: () => import("/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexY9cgNsjit6XOFUtw9IUbDJ_459Wh2Gz3pxj9M6eGRI8ZAMeta || {},
    component: () => import("/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexvHIyihS_45_45JoZ_m7pyXlTn7AZ7hrC_4SMid8bIehMXuIMeta || {},
    component: () => import("/codebuild/output/src1435116656/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]